module.exports = __webpack_public_path__ + "static/img/3.6c8f593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/3.png
// module id = zN3v
// module chunks = 1